import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import SharedConstraintFields from './shared-fields';
import NumericField from '../../numeric-field';
import constraintInputNames from '../optimizer-utils/input-names';

type AssetVolumeProps = {
  id: string;
  params: types.optimizer.AssetVolumeDraft;
  setParams: (_params: types.optimizer.AssetVolumeDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const AssetVolume = ({ id, params, setParams, readOnly, validationDef }: AssetVolumeProps) => {
  const [showMore, setShowMore] = React.useState(false);
  return (
    <mui.core.Box p={2}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid item xs={12} md={4}>
          <NumericField
            textFieldProps={{
              label: constraintInputNames.max_position_days,
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              error: validationDef?.fields?.includes(`max_position_days_${id}`),
            }}
            disabled={readOnly}
            value={params.max_position_days}
            setValue={(v) => setParams({ ...params, max_position_days: v })}
          />
        </mui.core.Grid>

        <mui.core.Grid item xs={12} md={4}>
          <NumericField
            textFieldProps={{
              label: constraintInputNames.max_trade_days,
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              error: validationDef?.fields?.includes(`trade_days_${id}`),
            }}
            disabled={readOnly}
            value={params.max_trade_days}
            setValue={(v) => setParams({ ...params, max_trade_days: v })}
          />
        </mui.core.Grid>

        <mui.core.Grid item xs={12} md={4}>
          <NumericField
            textFieldProps={{
              label: 'Trade Days Decrease Multiplier',
              fullWidth: true,
              required: true,
              variant: 'outlined',
              size: 'small',
              error: validationDef?.fields?.includes(`trade_days_decrease_${id}`),
            }}
            disabled={readOnly}
            value={params.trade_days_decrease_multiplier}
            setValue={(v) => setParams({ ...params, trade_days_decrease_multiplier: v })}
          />
        </mui.core.Grid>

        <mui.core.Grid item xs={12} md={12}>
          <mui.core.Box ml={3}>
            <mui.core.FormControlLabel
              control={
                <mui.core.Switch
                  size="small"
                  checked={params.exempt_funding_trade}
                  onChange={() =>
                    setParams({
                      ...params,
                      exempt_funding_trade: !params.exempt_funding_trade,
                    })
                  }
                  disabled={readOnly}
                />
              }
              label="Exempt Funding Trade"
            />
          </mui.core.Box>
        </mui.core.Grid>
        {showMore && (
          <mui.core.Box px={5}>
            <SharedConstraintFields
              params={params}
              setParams={setParams}
              showRelaxation={false}
              readOnly={readOnly}
              validationDef={validationDef}
            />
          </mui.core.Box>
        )}
        <mui.core.Box p={5}>
          <mui.core.Button
            onClick={() => {
              setShowMore(!showMore);
            }}
            color="primary"
            sx={{ mb: 2 }}
            startIcon={showMore ? <mui.icons.Remove /> : <mui.icons.Add />}
          >
            {showMore ? <>Show Less</> : <>Show More</>}
          </mui.core.Button>
        </mui.core.Box>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default AssetVolume;
